import { ApiBase } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ScheduleFieldEntity } from './schedule-field-entity';

@inject(IHttpClient)
export class ScheduleFieldApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async listByScheduleId(eventId: string, scheduleId: string): Promise<ScheduleFieldEntity[]> {
        const response = await this.get(this._baseUrl(eventId, scheduleId));
        return ScheduleFieldEntity.fromDtoArray(response.content);
    }

    public async put(eventId: string, scheduleId: string, fieldNumber: number, venueId: string | null): Promise<void> {
        await this.patch(this._baseUrl(eventId, scheduleId) + '/' + fieldNumber, { venueId });
    }

    private _baseUrl(eventId: string, scheduleId: string): string {
        return `api/events/${eventId}/schedules/${scheduleId}/fields`;
    }
}
